/** Starter questions per group-page tab. Unknown tabs fall back to `general`. */
const GENERAL = ['How do I set up reminders?', 'What should I do before sending invites?'];

const BY_TAB: Record<string, string[]> = {
  guests: ["Who hasn't replied yet?", 'How many guests have RSVPed yes?'],
  rooms: ['How many rooms are left?', 'Which guests still need a room?'],
  dinners: ['Which dinner still has seats?', 'Who has claimed a dinner spot?'],
  broadcasts: ["What's scheduled to send?", 'When did I last message guests?'],
  seating: ["Who isn't seated yet?", 'How many tables are full?'],
};

export function suggestionsForTab(tab: string | undefined): string[] {
  return [...(tab && BY_TAB[tab] ? BY_TAB[tab] : []), ...GENERAL].slice(0, 3);
}
